var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentUser.is_superuser)?_c('admin-home'):_c('user-home')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }